import { css } from "@emotion/react";
import { LoadingBubblesProps } from "./types";
import { bubbleStyles } from "./style";
import { FC } from "react";

/**
 * Bubbles is a loading spinner component that displays a series of animated bubbles.
 * This is commonly used to indicate that a process is ongoing, such as waiting for a response.
 */
export const LoadingBubbles: FC<LoadingBubblesProps> = ({
  color = "var(--color-splash-primary)",
  "data-testid": dataTestId
}) => {
  return (
    <div
      className="kit-LoadingBubbles"
      data-testid={dataTestId}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
      css={[bubbleStyles.wrapper]}
    >
      {Array.from({ length: 7 }, (_, i) => i).map(index => (
        <div
          key={index}
          css={[
            css`
              background-color: ${color};
              --bubble-animation-delay: ${index * 0.07}s;
            `,
            bubbleStyles.bubble
          ]}
        />
      ))}
    </div>
  );
};
